import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import { actionAddAffiliatePrograms } from '../../affiliateProgram/actions/affiliateProgram';

import { CAMPAIGNS_SCHEMA } from '../schemas';

import {
  ACTION_ADD_CAMPAIGNS,
  ACTION_LOAD_CAMPAIGN_NAMES__REQUEST,
  ACTION_LOAD_CAMPAIGN_NAMES__SUCCESS,
  ACTION_LOAD_CAMPAIGN_NAMES__FAIL,
  ACTION_CREATE_CAMPAIGN__REQUEST,
  ACTION_CREATE_CAMPAIGN__FAIL,
  ACTION_CREATE_CAMPAIGN__SUCCESS,
  ACTION_EDIT_CAMPAIGN__REQUEST,
  ACTION_EDIT_CAMPAIGN__SUCCESS,
  ACTION_EDIT_CAMPAIGN__FAIL,
  ACTION_SWITCH_CAMPAIGN_STATUS__REQUEST,
  ACTION_SWITCH_CAMPAIGN_STATUS__FAIL,
  ACTION_SWITCH_CAMPAIGN_STATUS__SUCCESS,
} from '../actionTypes';
import { MODAL_DIALOG__EDIT_CAMPAIGN } from '../constants/dialogs';

import { getModalDataByName } from 'react-redux-app/lib/modules/modal/selectors';


export const actionAddCampaigns = campaigns => ({
  type: ACTION_ADD_CAMPAIGNS,
  payload: { campaigns },
});


const actionLoadCampaignNamesSuccess = campaignIds => ({
  type: ACTION_LOAD_CAMPAIGN_NAMES__SUCCESS,
  payload: { campaignIds },
});

const actionLoadCampaignNamesFail = error => ({
  type: ACTION_LOAD_CAMPAIGN_NAMES__FAIL,
  payload: { error },
});

export const actionLoadCampaignNamesRequest = (filter = {}) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_CAMPAIGN_NAMES__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/campaign',
      {
        params: {
          sortField: 'name',
          sortDirection: 'asc',
          ignoreDefaultLimit: true,
          ...filter,
        },
      },
      CAMPAIGNS_SCHEMA
    ).then(
      ({ entities, result }) => {
        dispatch(actionAddAffiliatePrograms(entities.affiliatePrograms || {}));
        dispatch(actionAddCampaigns(entities.campaigns || {}));
        dispatch(actionLoadCampaignNamesSuccess(result.items));
      },
      error => {
        dispatch(actionLoadCampaignNamesFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionCreateCampaignSuccess = () => ({
  type: ACTION_CREATE_CAMPAIGN__SUCCESS,
});

const actionCreateCampaignFail = error => ({
  type: ACTION_CREATE_CAMPAIGN__FAIL,
  payload: { error },
});

export const actionCreateCampaignRequest = (name, affProgramId) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_CREATE_CAMPAIGN__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/campaign',
      { data: { name, affProgramId } }
    ).then(
      () => {
        dispatch(actionCreateCampaignSuccess());
      },
      error => {
        dispatch(actionCreateCampaignFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionEditCampaignSuccess = () => ({
  type: ACTION_EDIT_CAMPAIGN__SUCCESS,
});

const actionEditCampaignFail = error => ({
  type: ACTION_EDIT_CAMPAIGN__FAIL,
  payload: { error },
});

export const actionEditCampaignRequest = name => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_EDIT_CAMPAIGN__REQUEST,
    });

    const { campaignId } = getModalDataByName(getState(), MODAL_DIALOG__EDIT_CAMPAIGN);

    return apiClientHelper.put(
      '/rest/webmaster/campaign',
      { data: { name, id: campaignId } }
    ).then(
      () => {
        dispatch(actionEditCampaignSuccess());
      },
      error => {
        dispatch(actionEditCampaignFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionSwitchCampaignStatusSuccess = () => ({
  type: ACTION_SWITCH_CAMPAIGN_STATUS__SUCCESS,
});

const actionSwitchCampaignStatusFail = error => ({
  type: ACTION_SWITCH_CAMPAIGN_STATUS__FAIL,
  payload: { error },
});

export const actionSwitchCampaignStatusRequest = (campaignId, status) => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_SWITCH_CAMPAIGN_STATUS__REQUEST,
      payload: { campaignId },
    });

    return apiClientHelper.post(
      `/rest/webmaster/campaign/${campaignId}/switch_status/${status}`
    ).then(
      () => {
        dispatch(actionSwitchCampaignStatusSuccess());
      },
      error => {
        dispatch(actionSwitchCampaignStatusFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
